import React from 'react'
import PropTypes from 'prop-types'

export interface EmptyResultsProps {
  popularSearches: Array<{
    title: string
    url: string
    search_string: string
  }>
}

function EmptyResults (props: EmptyResultsProps): React.ReactElement {
  return (
    <div id='empty-search-result' className='grid-x'>
      <div className='small-12 medium-10 medium-offset-1 large-8 large-offset-2 cell empty-result-content'>
        <h2>No results based on your criteria</h2>
        <h3><i className='far fa-arrow-right' /> We'll track it down for you</h3>
        <p>New suppliers are being reviewed every day but there are still many suppliers who have not yet been reviewed.
          If you don't find the information you're looking for, please contact us and we'll track it down for you.
          <a href='mailto:support@procurated.com'>Click here to get in touch</a>.
        </p>
        <h4>Suggestions:</h4>
        <ul>
          <li>Try changing your search criteria or filters</li>
          <li>You can find results based on categories</li>
          <li>Make sure all words are spelled correctly</li>
          <li>Try more general keywords</li>
        </ul>
      </div>
      <div className='small-12 medium-10 medium-offset-1 large-8 large-offset-2 cell popular-searches'>
        <h4>Try popular search categories</h4>
        <p>Head straight to the results you want by clicking one of these relevant tags</p>
        <div className='grid-x'>
          {props.popularSearches.map((popularSearch) => {
            return (
              <div className='shrink cell item' key={popularSearch.search_string}>
                <a href={popularSearch.url}>
                  <i className='far fa-search' /> <span>{popularSearch.title}</span>
                </a>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

EmptyResults.propTypes = {
  popularSearches: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    search_string: PropTypes.string.isRequired
  })).isRequired
}

export default EmptyResults
